if (!customElements.get('package-upsell')) {
  class PackageUpsell extends HTMLElement {
    connectedCallback() {
      this.checkbox = this.querySelector('[data-package-upsell]');
      this.targetSize = (this.dataset.targetSize || '').trim().toLowerCase();
      this._onVariantChange = this.onVariantChange.bind(this);
      document.addEventListener('variant:changed', this._onVariantChange);
    }

    disconnectedCallback() {
      document.removeEventListener('variant:changed', this._onVariantChange);
    }

    onVariantChange() {
      const node = this.closest('.shopify-section')?.querySelector(
        'variant-selects [data-selected-variant]'
      );
      let variant = null;
      try {
        variant = node ? JSON.parse(node.innerHTML) : null;
      } catch (e) {
        variant = null;
      }
      this.update(variant);
    }

    update(variant) {
      const matches = this.variantMatches(variant);
      this.hidden = !matches;
      if (!matches && this.checkbox) this.checkbox.checked = false;
    }

    variantMatches(variant) {
      if (!variant || !this.targetSize) return false;
      const options = (variant.options || []).map((o) => String(o).trim().toLowerCase());
      if (options.includes(this.targetSize)) return true;
      return String(variant.title || '')
        .toLowerCase()
        .split('/')
        .map((s) => s.trim())
        .includes(this.targetSize);
    }

    shouldAdd() {
      return !this.hidden && !!this.checkbox && this.checkbox.checked;
    }

    get packageVariantId() {
      return this.getAttribute('data-package-variant-id');
    }
  }

  customElements.define('package-upsell', PackageUpsell);
}
